import w1 from "../../imgs/gallery/w1.jpg";
import w2 from "../../imgs/gallery/w2.jpg";
import w3 from "../../imgs/gallery/w3.jpg";
import w4 from "../../imgs/gallery/w4.jpg";
import w5 from "../../imgs/gallery/w5.jpg";
// import t1 from "../../imgs/gallery/t1.jpg";
import t2 from "../../imgs/gallery/t1.jpg";
import t3 from "../../imgs/gallery/t3.jpg";
import t4 from "../../imgs/gallery/t4.jpg";
import t5 from "../../imgs/gallery/t5.jpg";
import t6 from "../../imgs/gallery/t6.jpg";

export const photos = [
  {
    src: w1,
    width: 1545,
    height: 1024,
  },
  {
    src: t4,
    width: 1024,
    height: 1545,
  },
  {
    src: w2,
    width: 1415,
    height: 932,
  },
  {
    src: t2,
    width: 1440,
    height: 1800,
  },
  {
    src: w3,
    width: 1545,
    height: 1024,
  },
  {
    src: w4,
    width: 1545,
    height: 1024,
  },
  {
    src: t3,
    width: 1024,
    height: 1545,
  },
  {
    src: w5,
    width: 1818,
    height: 1228,
  },
  {
    src: t6,
    width: 1024,
    height: 1545,
  },
  {
    src: t5,
    width: 1024,
    height: 1545,
  },
];
